import React, { ReactNode, FC } from "react";
import { Link } from 'react-router-dom';
import classNames from "classnames";
import styles from "./styles.module.scss";

export enum ArrowDirection {
  Up = "up",
  Down  = "down",
  Left = "left",
  Right = "right"
}

export enum ButtonStyle {
  Primary = "primary",
  Secondary  = "secondary",
  None = "none",
  Full = "full",
  Underline = "underline",
  Icon = 'icon',
  SkinnyPrimary = 'skinnyPrimary',
  SkinnySecondary = 'skinnySecondary',
}

export enum ArrowPosition {
  Left = "left",
  Right  = "right",
}

export interface IButtonProps {
  children?: ReactNode;
  style?: ButtonStyle;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  key?: string;
  type?: "submit" | "button" | "reset" | undefined;
  loading?: boolean;
}

export interface LinkButtonProps extends IButtonProps {
  to: { pathname: string | undefined, state?: any };
};

interface ArrowLinkProps extends IButtonProps {
  to: string;
  arrowPosition?: ArrowPosition;
  arrowDirection?: ArrowDirection;
  onClick?: () => void;
};

interface ArrowButtonProps extends IButtonProps {
  clickAction: () => void;
  arrowPosition?: ArrowPosition;
  arrowDirection?: ArrowDirection;
};

export const LinkButton: FC<LinkButtonProps> = ({
  to,
  style= ButtonStyle.Primary,
  children,
  className,
}) => {
  return (
    <Link
      to={to}
      className={classNames(styles.button, styles.linkButton, style && styles[style], className)}
    >
      {children}
    </Link>
  );
};

export const ArrowLink: FC<ArrowLinkProps> = ({
  to,
  arrowPosition= ArrowPosition.Left,
  arrowDirection= ArrowDirection.Left,
  children,
  className,
  onClick
}) => {
  return (
    <Link
      to={to}
      className={classNames(className)} 
      onClick={onClick}
    >
      <p className={styles.arrowLink}>
        { arrowPosition === ArrowPosition.Left && <i className={classNames(className, styles.arrowClass, `pos-${arrowPosition}` && styles[`pos-${arrowPosition}`], arrowDirection)}></i> }
        {children}
        { arrowPosition === ArrowPosition.Right && <i className={classNames(className, styles.arrowClass, `pos-${arrowPosition}` && styles[`pos-${arrowPosition}`], arrowDirection)}></i> }
      </p>
    </Link>
  );
};

export const ArrowButton: FC<ArrowButtonProps> = ({
  style = ButtonStyle.None,
  clickAction,
  arrowPosition= ArrowPosition.Left,
  arrowDirection= ArrowDirection.Left,
  children,
  className = "",
}) => {
  return (
      <button onClick={clickAction} className={classNames(styles.button, styles.arrowButton, className)}>
        { arrowPosition === ArrowPosition.Left && <i className={classNames(styles.arrowClass,
                                                                arrowPosition && styles[`pos-${arrowPosition}`], 
                                                                arrowDirection && styles[arrowDirection])}></i> }
        {children}
        { arrowPosition === ArrowPosition.Right && <i className={classNames(styles.arrowClass, 
                                                                styles[style],
                                                                arrowPosition && styles[`pos-${arrowPosition}`], 
                                                                arrowDirection && styles[arrowDirection])}></i> }
      </button >
  );
};

export const Button: FC<IButtonProps> = ({
  style = ButtonStyle.Primary,
  children,
  className,
  loading = false,
  onClick = () => {},
  disabled = false,
  type="submit"
}) => {
  if (style === 'none') {
    return (<button
      className={classNames(className, styles.button, styles.none)}
      tabIndex={0}
      role="button"
      {...{
        disabled,
        onClick,
        onKeyPress: onClick,
        type
      }}
    >
      {children}
    </button>);
  }

  return (
    <button
      className={classNames(styles.button, style && styles[style], className)}
      {...{
        disabled,
        onClick,
        type
      }}
    >
      {loading ? <div className={styles.loadingContainer}>
        <div className={styles.loading}>
        </div>
      </div> : children}
    </button>
  );
};
